import type { FieldPayload } from '@FormModule';
import type { GenericField } from '@Types';
import { getPayloadEventDateString } from '@Helpers';
import { payloadSanitizerHelper } from '@FormModule';

function getSanitizedFieldPerName({ name, value }: FieldPayload) {
  switch (name) {
    case 'paid_date': {
      return {
        paid_date: getPayloadEventDateString(value),
      };
    }
    case 'cash_drawer': {
      return {
        cash_drawer: value.label,
        cash_drawer_id: value?._id?.$oid,
      };
    }
    case 'cash_amount_collected': {
      return {
        cash_amount_collected: value != null ? Number(value) : undefined,
      };
    }
    // NOTE :: This helper does not send a card token or live Stripe objects. The browser confirms
    // the card after this payload is built. The caller then adds `payment_intent_id`
    // (`useStripeCardConfirm`).
    case 'stripe': {
      return {
        name_on_card: value.cardHolderName,
      };
    }
    case 'split_payment': {
      const {
        card_reader_amount,
        cash_amount,
        check_amount,
        check_number,
        credit_card_amount,
        last_four_digits,
        name_on_card,
        other_amount,
      } = value;

      return {
        name_on_card: credit_card_amount > 0 ? name_on_card : undefined,
        last_four_digits: card_reader_amount > 0 ? last_four_digits : undefined,
        check_number: check_amount > 0 ? check_number : undefined,
        split_payment_details: {
          card_reader_amount,
          cash_amount,
          check_amount,
          credit_card_amount,
          other_amount,
        },
      };
    }
  }
}

export default function (fields: Set<GenericField>, shelterProfile: any, isSplitPayment: boolean) {
  let payload: { [key: string]: any } = {};
  const fieldNamesToBeSanitezed = ['cash_amount_collected', 'paid_date', 'stripe'];

  const hasCashDrawer = shelterProfile?.cash_drawer;
  if (hasCashDrawer) fieldNamesToBeSanitezed.push('cash_drawer');

  const hasSplitPayment = shelterProfile?.enable_split_payments && isSplitPayment;
  if (hasSplitPayment) fieldNamesToBeSanitezed.push('split_payment');

  fields.forEach((field: GenericField) => {
    const entry = payloadSanitizerHelper(field, fieldNamesToBeSanitezed, getSanitizedFieldPerName);
    payload = { ...payload, ...entry };
  });

  return payload;
}
